export default {
  state: () => ({
    gameName: '',
    pythonCode: '',
    gameList: localStorage.gameList
      ? JSON.parse(localStorage.gameList)
      : [],
  }),
  getters: {
    gameName: (state) => state.gameName,
    pythonCode: (state) => state.pythonCode,
    gameList: (state) => state.gameList,
  },
  mutations: {
    getPythonCode(state, pythonCode) {
      state.pythonCode = pythonCode
    },
    setGameList(state, list) {
      state.gameList = list
      if (typeof list == 'object') {
        localStorage.gameList = JSON.stringify(list)
      }
      // console.log('list--', this.list)
    },
    //生成游戏列表
    createGame(state) {
      let { pythonCode } = state
      let gameName = localStorage.gameName
      state.gameList.push({
        gameName,
        pythonCode,
      })
      localStorage.gameList = JSON.stringify(state.gameList)
      console.log('localStorage.gameList ', localStorage.gameList)
    },
  },
  actions: {},
}
